import { Badge, Col, Descriptions, Divider, Row, Tabs } from "antd";
import { MidserviceMessagesTab } from "../components/MidserviceMessagesTab";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import {
  resetNewImagesCounter,
  resetNewLogsCounter,
  selectFullMidservice,
  selectNewImages,
  selectNewLogs,
} from "../redux/slices/midservice/midserviceSlice";
import "./KKMPage.css";
import { ImagesView } from "../components/ImagesView";
import { DeviceDescription } from "../components/DeviceDescription";
import React from "react";
import { LogsTab } from "./LogsTab";

export const KKMPage = (): JSX.Element => {
  const fullInstance = useAppSelector(selectFullMidservice);
  const newLogs = useAppSelector(selectNewLogs);
  const newImages = useAppSelector(selectNewImages);
  const dispatch = useAppDispatch();

  const onActiveTabChange = (activeKey: string): void => {
    switch (activeKey) {
      case "logs":
        dispatch(resetNewLogsCounter());
        break;
      case "images":
        dispatch(resetNewImagesCounter());
        break;

      default:
        break;
    }
  };

  return (
    <>
      <Row gutter={[48, 40]} style={{ height: "calc(100vh - 7rem)" }}>
        <Col span={16}>
          <Tabs
            tabBarStyle={{ padding: "0px" }}
            defaultActiveKey="interaction"
            onChange={onActiveTabChange}
            // type="card"
            // size="large"
            items={[
              {
                label: `Взаимодействие`,
                key: "interaction",
                children: <MidserviceMessagesTab />,
              },
              {
                label: (
                  <Badge size="small" count={newLogs} offset={[10, 0]}>
                    Логи
                  </Badge>
                ),
                key: "logs",
                children: (
                  <LogsTab
                    fullDeviceId={
                      fullInstance?.midserviceInstance.deviceId ?? ""
                    }
                    midserviceType={
                      fullInstance?.midserviceInstance.instanceType ?? "KKM"
                    }
                    logs={fullInstance?.logs ?? []}
                    apiLogs={fullInstance?.apiLogs ?? []}
                  />
                ),
              },
              {
                label: (
                  <Badge size="small" count={newImages} offset={[10, 0]}>
                    Скриншоты
                  </Badge>
                ),
                key: "images",
                children: <ImagesView images={fullInstance?.images} />,
              },
            ]}
          />
        </Col>
        <Col span={8} style={{ borderLeft: "1px solid #d9d9d9" }}>
          <DeviceDescription fullInstance={fullInstance} instanceType="kkm" />
          <Divider />
          <Descriptions title="Статистика" column={1}>
            <Descriptions.Item label="Количество чеков">
              {fullInstance?.midserviceInstance?.status?.appdata?.cheques}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </>
  );
};
